import styled from 'styled-components';

export const Layout = styled.main`
  color: var(--color-theme-base-inverse);
  background: var(--color-theme-base-dark);
`;
